import React from 'react';

import PropTypes from 'prop-types';

const AdminMenu = ({ history }) => {
  return (
    <>
      <div className="row w-100 text-form justify-content-center">
        <div>
          <button
            className="admin-button"
            onClick={() => {
              history.push('/admin-dashboard/card-manager');
            }}
          >
            Administrar Tarjetas
          </button>
          <button
            className="admin-button"
            onClick={() => {
              history.push('/admin-dashboard/buildings');
            }}
          >
            Administrar Edificios
          </button>
          <button
            className="admin-button"
            onClick={() => {
              history.push('/admin-dashboard/users');
            }}
          >
            Administrar Usuarios
          </button>
          <button
            className="admin-button"
            onClick={() => {
              history.push('/admin-dashboard/readers');
            }}
          >
            Administrar Lectoras Nuevas
          </button>
          <button
            className="admin-button"
            onClick={() => {
              history.push('/admin-dashboard/events/event-intrusion');
            }}
          >
            Monitoreo de Intrusos
          </button>
          <button
            className="admin-button"
            onClick={() => {
              history.push('/admin-dashboard/events/open-door');
            }}
          >
            Monitoreo Puertas Abiertas
          </button>
        </div>
      </div>
    </>
  );
};
AdminMenu.propTypes = {
  history: PropTypes.object,
};
export default AdminMenu;
